import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_ROUTE_COST_RESET = 'DELETE_ROUTE_COST_RESET';
export const DELETE_ROUTE_COST_LOADING = 'DELETE_ROUTE_COST_LOADING';
export const DELETE_ROUTE_COST_SUCCESS = 'DELETE_ROUTE_COST_SUCCESS';
export const DELETE_ROUTE_COST_REJECT = 'DELETE_ROUTE_COST_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteRouteCostReset = () => ({ type: DELETE_ROUTE_COST_RESET });
export const deleteRouteCostLoading = () => ({ type: DELETE_ROUTE_COST_LOADING });
export const deleteRouteCostSuccess = (payload) => ({ type: DELETE_ROUTE_COST_SUCCESS, payload });
export const deleteRouteCostReject = (payload) => ({ type: DELETE_ROUTE_COST_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deleteRouteCostRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.DELETE,
    }, getState);
    return request(`/Route/web/DeleteRouteCost?Id=${data.id}&IdRoute=${data.idRoute}`, options);
};
